import http from "../../services/httpService";
import { MDCRipple } from '@material/ripple';
import { openSnackbar, snackbarModel } from "./snackbar";
import { openDialog, dialogModel } from "./dialog";

const closeError = function (errorMessage) {
    errorMessage.removeClass('active');

    setTimeout(function () {
        errorMessage.remove();
    }, 300);
};

export function initGlobal() {
    // Init material components
    window.mdc.autoInit();
    mdcInitButtons();

    //default datepicker setup
    initDatePicker();


    showActionMessageOnPageLoad();

    initToggleRotate();
    initToggleIconRotate();

    initFooterNewsletterSignup();

    $('[data-toggle="tooltip"]').tooltip();
}

async function initFooterNewsletterSignup() {

    $('#footer-nl-signup').off('click').on('click', async function () {

        var emailAddressValue = $('#footer-nl-signup-email-address').val();

        if (isEmpty(emailAddressValue)) {

            openSnackbar({
                ...snackbarModel,
                content: 'An email address must be entered to sign up for the newsletter'
            });

            return;
        }


        const buttonTextWrapper = $('.footer-newsletter-signup-text-wrapper');
        const activityIndicators = $('.footer-newsletter-signup-activity');

        buttonTextWrapper.hide();
        activityIndicators.show().css("display", "inline-block");

        setTimeout(async function () {

            const formValues = { emailAddress: emailAddressValue };

            //attempt POST save, the check response
            const response = await signupForNewsletterService(formValues);

            if (response.responseType === "SUCCESS") {

                openSnackbar({
                    ...snackbarModel,
                    content: "Thanks! We've signed you up for the Hayter newsletter",
                    remain: true
                });

                $('#footer-nl-signup-email-address').val('');
            }
            else {
                //display failure notification in some way
                var failureMessage = response.responseMessage;

                //display failure snackbar
                openSnackbar({
                    ...snackbarModel,
                    content: failureMessage,
                    remain: true
                });
            }

            buttonTextWrapper.show();
            activityIndicators.show().css("display", "none");

        }, 1000);

    });
}

async function signupForNewsletterService(data) {

    //no TRY CATCH as handled by parent
    //calls a service to sign the passed email address up for the newsletter
    const response = await http.post('/post-newsletter-signup', data);

    return response.data;
}

export function initDatePicker(wrapper) {

    // Default Date Picker. Docs: https://github.com/T00rk/bootstrap-material-datetimepicker
    // This one looks better but has less functionality... https://github.com/FreddyFY/material-datepicker
    var mdcDatePickerSelector = '.mdc-datepicker';

    if (!isEmpty(wrapper)) {

        mdcDatePickerSelector = wrapper + ' .mdc-datepicker';
    } 

    if ($(mdcDatePickerSelector).length) {

        const mdcDatePicker = $(mdcDatePickerSelector).bootstrapMaterialDatePicker({
            time: false,
            format: 'DD/MM/YYYY',
            weekStart: 1,
            clearButton: true,

            //ML - it's always annoyed me that you have to click 'ok' to confirm a date change. the following setting configures the datepicker to 'make' 
            //the change when you click on a day option.
            switchOnClick: true
        });

        mdcDatePicker.bind('beforeChange', function (event, date) {
            $(this).parent().find('.mdc-floating-label').addClass('mdc-floating-label--float-above');
        });

        mdcDatePicker.bind('close', function (event, date) {

            //NOTE: originally bound this to dateChanged but found that validation didn't fire when the clear option was used.
            //binding it to the close event covers this action as well.

            //we  need to assign the virtual element selector $(this) to a variable as we need to wrap the next check in a setTimeout
            //and why do we do this? because the dateSelector fires instantly and the linked input hasn't yet changed. a 100ms delay is enough to allow this to happen
            var element = $(this);

            setTimeout(function () {

                if (element.closest('form').length) {

                    if (element.valid()) {

                        //once the element is validation checked then remove the additional mdc error class from the parent div (but only if the item has passed validation).
                        var parent = element.closest('.mdc-text-field');

                        parent.removeClass('mdc-text-field--invalid');
                    }
                }

            }, 100);
        });
    }
}


export const actionMessage = () => {
    if ($('.action-message-wrapper').length > 0) {
        setTimeout(() => {
            $('.action-message-wrapper').not('.remain').slideUp(500);
        }, 3000);
    }
};

export function showActionMessageOnPageLoad() {
    if (typeof actionMessageData !== 'undefined') {
        openSnackbar(actionMessageData);
    }
}

//DW, Convert to util function or Prototype?
export const isEmpty = (value) => {
    return typeof value === 'string' && !value.trim() || typeof value === 'undefined' || value === null;
};

//DW, Convert to util function or Prototype?
export const isNumeric = (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
};

//DW, Convert to util function or Prototype?
//ML, source: https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
export const formatNumberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const setDisabledProperty = (object, disabled) => {
    object.prop("disabled", disabled);
};

export function initInputTransition() {
    $(".custom-transition").focus(function () {
        $(this).addClass("transition-active");
    }).blur(function () {
        $(this).removeClass("transition-active");
    });
}

export function initInputGroupTransition() {
    $(".input-group.custom-transition .form-control").focus(function () {
        $(this).parent('.custom-transition').addClass("transition-active");
    }).blur(function () {
        $(this).parent('.custom-transition').removeClass("transition-active");
    });
}

export function rotateElement(element, degrees) {

    var rotationClass = 'rotate-' + degrees;

    //rotate the given element 180 degrees via the power of css
    if (element.hasClass(rotationClass)) {
        element.removeClass(rotationClass);
    }
    else {
        element.addClass(rotationClass);
    }
}

export function error(message, ex, persistMessage = true) {
    // If an exception is passed, log it to the console.
    ex && console.error(ex);

    // Add global error message to the DOM
    $('body').append('<div class="global-error-message"><span class="error-message-content">' + message + '</span><a href="#" class="mdc-button float-right close-global-error">close</a></div>');

    // Bind events
    setTimeout(function () {
        var newMessage = $('.global-error-message').last();
        newMessage.addClass('active');

        newMessage.find('.close-global-error').click(function (e) {
            e.preventDefault();
            closeError(newMessage);
        });

        if (!persistMessage) {
            setTimeout(function () {
                closeError(newMessage);
            }, 1000 * 10);
        }

    }, 100);
}

export function consoleLog(message) {
    //if (appSettings.ShowConsoleErrors)
    console.log(message);
}

export const mdcInitButtons = () => {
    var buttons = document.getElementsByClassName('mdc-button');
    if (buttons.length > 0) {
        for (var i = 0; i < buttons.length; i++) {
            new MDCRipple(buttons[i]);
        }
    }
};

export function mdcSetValue(inputElement, value) {
    //Populate textbox, listbox, etc. and put labels in the right place

    inputElement.val(value);

    var labelParent = inputElement.next('div');
    var label = labelParent.find('.mdc-floating-label');

    if (value === "") {
        labelParent.removeClass('mdc-notched-outline--notched');
        label.removeClass('mdc-floating-label--float-above');
    }
    else {
        labelParent.addClass('mdc-notched-outline--notched');
        label.addClass('mdc-floating-label--float-above');
    }
}

export const getThis = (currentItem) => {
    //NOTE: pass obj.currentTarget through to this method for it to return the jquery object for the entity in question
    return $(currentItem);
};

export function refreshInlineValidation() {
    $('.mdc-text-field__input:not(.input-validation-error)').parent('.mdc-text-field').removeClass('mdc-text-field--invalid');
    $('.input-validation-error').parent('.mdc-text-field').addClass('mdc-text-field--invalid');
}

export function initToggleRotate() {

    //sets up binding to rotate the targeted element
    //useful if you only want to specifically rotate the target element

    bindRotateClass(180);
    bindRotateClass(90);
    bindRotateClass(45);
}

function bindRotateClass(degrees) {

    var rotateIconClass = '.toggle-rotate-' + degrees;

    $(rotateIconClass).off('click').on('click', function () {
        rotateElement($(this), degrees);
    });
}

export function initToggleIconRotate() {

    //sets up binding to rotate any <i> elements found in the targeted element
    //useful if you only want an icon to rotate when a parent element is clicked
    bindIconRotateClass(180);
    bindIconRotateClass(90);
    bindIconRotateClass(45);
}

function bindIconRotateClass(degrees) {

    var rotateIconClass = '.toggle-icon-rotate-' + degrees;

    $(rotateIconClass).off('click').on('click', function () {

        var icon = $(this);

        if (!icon.hasClass('rotatable')) {
            icon = $(this).find('.rotatable');
        }

        rotateElement(icon, degrees);
    });
}

export async function setActionMessage(messageType, message, remain, overrideClass) {

    //calls a server side service to set an 'action message'; this is a snackbar that will be displayed the next time a page is served.
    //this is useful when services are called via ajax and server side messaging is not directly available as part of the initial service call AND the 
    //result of the call causes the page to be refreshed or redirected.

    //NOTE: message type can only be one of the following options:

    //SUCCESS
    //WARNING
    //ERROR

    const data = {
        actionMessageTypeEnum: messageType,
        message: message,
        remain: remain,
        overrideClass: overrideClass
    };

    await callSetActionMessageService(data);
}

async function callSetActionMessageService(data) {

    //calls a service to set an action message that will be displayed upon the next page load
    const response = await http.post('/core/setactionmessageworker', data);

    return response.data;
}

export function isBrowserChrome() {

    //why not simply return the result of the predicate? it can return three answers; true, false and undefined. we just want true or false.
    if (navigator.userAgentData && navigator.userAgentData.brands && navigator.userAgentData.brands.some(b => b.brand === 'Google Chrome')) {
        return true;
    }

    return false;
}